import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';

import { HttpApiService } from '@recruitee/http';
import type { PaginationState } from '@recruitee/ngrx';
import type {
  ReferralFilterOptions,
  ReferralOfferAssignment,
  ReferralReward,
} from '@recruitee/referrals-types';

import type { FilterSet } from './offer-assignments.store';

@Injectable({ providedIn: 'root' })
export class OfferAssignmentsHttpService {
  constructor(private httpApi: HttpApiService) {}

  public loadOfferAssignments(params: FilterSet): Observable<{
    offerAssignments: ReferralOfferAssignment[];
    references: ReferralReward[];
    meta: PaginationState;
  }> {
    return this.httpApi.get('/offers/active', params);
  }

  public loadOfferAssignmentDetails(offerId: number): Observable<{
    offerAssignment: ReferralOfferAssignment;
  }> {
    return this.httpApi.get(`/offers/${offerId}`);
  }

  public loadOfferFilters(): Observable<ReferralFilterOptions> {
    return this.httpApi.get(`/offers/filters`);
  }
}
